// extracted by mini-css-extract-plugin
export default {"addPhotoButton":"AddPhotoAreaButton_addPhotoButton__4hjNZ","text":"AddPhotoAreaButton_text__FujFR","editMode":"AddPhotoAreaButton_editMode__wmV21"};